import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { colors } from "../../theme/colors";
import { FOOTER_ID } from "../layout/Footer";

type Props = {
  includeFooter?: boolean;
};

export const ReadingBar = ({ includeFooter = false }: Props) => {
  //Width State
  const [width, setWidth] = useState(0);

  useEffect(() => {
    document.body.addEventListener("touchmove", scrollHeight);
    window.addEventListener("scroll", scrollHeight);
    return () => window.removeEventListener("scroll", scrollHeight);
  });

  // scroll function
  const scrollHeight = () => {
    const el = document.documentElement;
    const scrollTop = el.scrollTop || document.body.scrollTop;
    const scrollHeight = el.scrollHeight || document.body.scrollHeight;
    const footer = document.getElementById(FOOTER_ID);

    // The length of the reading bar is calculateted based on the scroll position and the height of the footer which we do not want to include
    const percent =
      (scrollTop /
        (scrollHeight - el.clientHeight - (includeFooter ? 0 : footer?.clientHeight || 0))) *
      100;

    setWidth(percent);
  };

  return (
    <Box
      sx={{
        position: "fixed",
        zIndex: 1200,
        top: 0,
        width: "100%",
        height: "0.3rem",
        display: "flex",
        justifyContent: "flex-start"
      }}>
      <Box
        sx={{
          height: "100%",
          width: `${width}%`,
          backgroundColor: colors.yellow
        }}
      />
    </Box>
  );
};
export default ReadingBar;
